import React, { useEffect, useState } from 'react';
import SensorIcon from 'commons/src/components/sensors/SensorIcon';
import calcTextSize, { getParentSize } from './commonFunctions';

type ParentProps = {
    sensorType?: string;
    headerText: string;
    subHeaderText: string;
    id: string;
    numberOfTilesInWidth: number;
};

export type Props = ParentProps;

export const PublicDashboardTileHeaderComponent = (props: Props): React.ReactElement => {
    const { sensorType, headerText, subHeaderText, numberOfTilesInWidth, id } = props;
    const minFontHeader = '26px';
    const minFontSubHeader = '20px';
    const [headerFontSize, setHeaderFontSize] = useState(minFontHeader);
    const [subHeaderFontSize, setSubHeaderFontSize] = useState(minFontSubHeader);
    const [fontScaled, setFontScaled] = useState(false);

    const calcText = (
        text: HTMLElement,
        updateFont: (font: string) => void,
        elementType: string,
        minFontSize: number
    ): void => {
        const { parentWidth, parentHeight, textHeight } = getParentSize(text);
        let parentContainerHeight = parentHeight;
        if (elementType === 'header') parentContainerHeight *= 0.55;
        else parentContainerHeight *= 0.37;
        const maxTextGrowth = parentContainerHeight / textHeight;
        calcTextSize(text, parentWidth, updateFont, maxTextGrowth, minFontSize);
        setFontScaled(true);
    };

    const calculateTextSizes = () => {
        const headerElement = document.getElementById(`${id}-header`);
        const subheaderElement = document.getElementById(`${id}-sub-header`);
        if (headerElement) {
            calcText(headerElement, setHeaderFontSize, 'header', parseInt(minFontHeader, 10));
        }
        if (subheaderElement) {
            calcText(subheaderElement, setSubHeaderFontSize, 'subHeader', parseInt(minFontSubHeader, 10));
        }
    };

    useEffect((): void => {
        if (!fontScaled) {
            calculateTextSizes();
        }
    }, [numberOfTilesInWidth]);

    return (
        <div className="public-dashboard-tile__header">
            <div className="public-dashboard-tile__header__info">
                {sensorType && (
                    <div className="public-dashboard-tile__header__info__icon">
                        <SensorIcon sensor={sensorType} />
                    </div>
                )}
                <div className="public-dashboard-tile__header__info__text">
                    <h2
                        id={`${id}-header`}
                        className="public-dashboard-tile__header__info__values"
                        style={{ fontSize: headerFontSize }}
                    >
                        {headerText}
                    </h2>
                    <br />
                    <div
                        id={`${id}-sub-header`}
                        className="public-dashboard-tile__header__info__name"
                        style={{ fontSize: subHeaderFontSize }}
                    >
                        {subHeaderText}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PublicDashboardTileHeaderComponent;
